import MobileContent from './MobileContent'

export default MobileContent
